import { Link } from 'react-router-dom';

export default function ShareBanner() {
  return (
    <section className="py-16 bg-gradient-to-r from-pink-500 via-rose-500 to-yellow-500 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10 text-9xl flex items-center justify-around pointer-events-none select-none">
        <span>🦆</span><span>🦆</span><span>🦆</span><span>🦆</span><span>🦆</span>
      </div>
      <div className="relative z-10 max-w-3xl mx-auto px-4 text-center">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          Spread the Joy on Social! 🦆
        </h2>
        <p className="text-white/90 text-base sm:text-lg leading-relaxed mb-8">
          Found a duck? Hiding one? Share your moment with the whole Mommy Mingle community! Use the hashtag so we can find you and feature your duck in our gallery.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <div className="bg-white/20 backdrop-blur-sm border border-white/30 rounded-2xl px-8 py-4 text-white">
            <p className="text-xs font-semibold uppercase tracking-widest text-white/70 mb-1">Use the hashtag</p>
            <p className="text-2xl font-extrabold tracking-tight">#WhatTheDuck</p>
          </div>
          <div className="bg-white/20 backdrop-blur-sm border border-white/30 rounded-2xl px-8 py-4 text-white">
            <p className="text-xs font-semibold uppercase tracking-widest text-white/70 mb-1">Tag us on Instagram</p>
            <p className="text-2xl font-extrabold tracking-tight">@TheMommyMingle</p>
          </div>
        </div>
        <div className="mt-8 flex justify-center gap-4">
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            className="w-11 h-11 flex items-center justify-center bg-white/20 hover:bg-white/30 border border-white/30 rounded-full text-white transition-colors cursor-pointer"
          >
            <i className="ri-instagram-line text-xl"></i>
          </a>
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            className="w-11 h-11 flex items-center justify-center bg-white/20 hover:bg-white/30 border border-white/30 rounded-full text-white transition-colors cursor-pointer"
          >
            <i className="ri-facebook-fill text-xl"></i>
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            className="w-11 h-11 flex items-center justify-center bg-white/20 hover:bg-white/30 border border-white/30 rounded-full text-white transition-colors cursor-pointer"
          >
            <i className="ri-twitter-x-line text-xl"></i>
          </a>
        </div>

        {/* Events crosslink */}
        <div className="mt-8 pt-6 border-t border-white/20">
          <p className="text-white/70 text-sm mb-3">Want even more fun for the family?</p>
          <Link
            to="/events"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-white/20 hover:bg-white/30 border border-white/30 rounded-full text-white text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-calendar-event-line"></i>
            Looking for more to do? Check out local events
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
